import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import NachweisIcon from '#components/svg/icons/NavAusbildungsnachweise'
import StyledText from '#components/a/StyledText'
import {routeHelper} from '#config/routeKeys'
import Avatar from '#components/a/Avatar'
import {useUserInfo} from "#hooks/store/useUserInfo";
import SystemIcon from '#components/a/SystemIcon'

const NachweisKontrolleBenachrichtigung = (props) => {
  const onClickNotification = () => {
    props.onNotificationClick(routeHelper.uebersichtAusbildungsnachweise())
  }

  const text = i18n.t('notification_text_nachweis_kontrolle')

  return (
    <div
      role="button"
      tabIndex={0}
      className="notification"
      onClick={onClickNotification}
      onKeyPress={onClickNotification}>
      <SystemIcon />
      <StyledText text={text} modifier="notification"/>
      <div className="notification__icon notification__icon--right">
        <NachweisIcon/>
      </div>
    </div>
  )
}

export default NachweisKontrolleBenachrichtigung

NachweisKontrolleBenachrichtigung.propTypes = {
  senderId: PropTypes.number,
  onNotificationClick: PropTypes.func.isRequired,
}
